import { render, staticRenderFns } from "./ServiceRequestQuotationDesign.vue?vue&type=template&id=b0b99f40&"
import script from "./ServiceRequestQuotationDesign.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestQuotationDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports